import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'background',
    label: 'Background Color',
    type: types.COLOR_PICKER,
  },
  {
    key: 'app_image',
    label: 'App Image URL',
    type: types.OBJECT,
    options: false,
    children: [
      {
        key: 'url',
        label: 'Image URL',
        type: types.TEXT
      },
      {
        key: 'alt',
        label: 'Image Alt',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'title',
    label: 'Title',
    type: types.TEXT,
  },
  {
    key: 'description',
    label: 'Description',
    type: types.TEXT,
  },
  {
    key: 'btn_title',
    label: 'Button Title',
    type: types.TEXT,
  },
  {
    key: 'btn_url',
    label: 'Button URL',
    type: types.TEXT,
  },
  {
    key: 'andriod_url',
    label: 'Andriod URL',
    type: types.TEXT,
  },
  {
    key: 'ios_url',
    label: 'iOS URL',
    type: types.TEXT,
  },
];

const defaultProps = {
  background: '#cfd3d6',
  app_image: {
    url: 'https://genesis-cdn.ff.com/ffzero1/09_app/graphic-iphone-app.png',
    alt: 'FF Phone App'
  },
  title: 'The future at your fingertips',
  description: 'To experience the FFZERO1 Concept in augmented reality 3D, download the Faraday Future Concept App along with the sketch marker.',
  btn_title: 'Download Sketch Marker',
  btn_url: 'http://www.ff.com',
  andriod_url: 'http://www.ff.com',
  ios_url: 'http://www.ff.com'
};

export default {
  title: 'App Section',
  id: 'AppSection',
  propsSchema,
  defaultProps
};
